import * as React from 'react';
import Flex, { Props as FlexProps } from '../Flex/Flex';

export interface Props extends FlexProps {}

/**
 * Flex enabled input element component. Should be used in conjunction
 * with the Container and Content components for styling.
 */
const Input: React.FunctionComponent<Props> = (props: Props) => {
  return (
    <Flex { ...props }
        Component="input"
        className="Input"
        grow />
  );
};

export default Input;
